import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { fullBrandName } from 'utils/environment';

import { GeolocationPermissionModalView } from '../geolocation-permission-modal.view';
import { IGeolocationPermissionModalProps } from '../types';

const FULL_BRAND_NAME = fullBrandName();
/**
 *
 * GeolocationDeniedModal contains logic required to render UI
 *  view is split from this component to enable separate logic
 *  between web and app -> specifically, logic around opening
 *  native settings. also some copy differences
 *
 */
export const GeolocationDeniedModal: FC<IGeolocationPermissionModalProps> = ({
  isOpen,
  dismissModal,
}) => {
  const { formatMessage } = useIntl();
  return (
    <GeolocationPermissionModalView
      flowTestId="denied"
      isOpen={isOpen}
      dismissModal={dismissModal}
      modalBodyText={formatMessage(
        { id: 'updateBrowserLocationSettings' },
        { brand: FULL_BRAND_NAME }
      )}
      modalHeadingText={formatMessage({ id: 'enableLocationServices' })}
      openSettingsButtonText={formatMessage({ id: 'browserSettings' })}
    />
  );
};

export default GeolocationDeniedModal;
